{
  "name": "@ns/company-join",
  "version": "1.0.0",
  "description": "Description here soon.",
  "inputs": {},
  "outcomes": {
    "accept": {},
    "reject": {}
  }
}
